import { render, staticRenderFns } from "./ClockActions.vue?vue&type=template&id=2f9d0896&scoped=true&"
import script from "./ClockActions.vue?vue&type=script&lang=js&"
export * from "./ClockActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d0896",
  null
  
)

export default component.exports